import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { CreateProposalClientResponse } from '../@types/CreateProposal'

type Store = {
  hasCreatedProposal: boolean
  createProposal: CreateProposalClientResponse | null
  setCreateProposal: (value: CreateProposalClientResponse) => void
  setHasCreatedProposal: (value: boolean) => void
}

export const useCreateProposalStore = create<Store>()(
  devtools(
    (set) => ({
      hasCreatedProposal: false,
      createProposal: null,
      setCreateProposal: (createProposal) => set({ createProposal }),
      setHasCreatedProposal: (hasCreatedProposal) =>
        set({ hasCreatedProposal }),
    }),
    { name: 'CreateProposalStore' },
  ),
)
